import React from "react"
import { useFormikWizard } from "formik-wizard"
import steps from "./steps"

const checkProperties = (obj) => {
  for (let key in obj) {
    if (obj[key] !== null && obj[key] !== "") return false
  }
  return true
}

const CompNav = ({ currentStep, wizard }) => {
  const context = useFormikWizard()

  const checkStepName = () => {
    if (currentStep === "business_info") {
      return "Business Proprietor Information"
    } else {
      return "Other Stakeholders Information"
    }
  }

  const checkStepId = () => {
    if (currentStep === "basic_business_info") {
      return 1
    } else if (currentStep === "additional_info") {
      return 2
    } else {
      return 3
    }
  }

  return (
    <div className="container">
      <div className="row px-lg-5">
        <div className="business-title-step_wrapper pt-5 pb-2 border-bottom">
          <h4 className="current-step">{checkStepName()}</h4>
          <div className="tag">
            <span>
              {checkStepId()} of {steps.length}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}

export default CompNav
